/**
 * LBRGT: color swatches as a horizontal slider (variant-picker setting lbrgt_color_slider).
 * Wraps the swatch row, adds prev/next arrows that only show while there is more to scroll,
 * and keeps the selected swatch in view.
 */
(() => {
  const initSlider = (row) => {
    if (row.dataset.lbrgtSlider) return;
    row.dataset.lbrgtSlider = 'true';

    const wrap = document.createElement('div');
    wrap.className = 'lbrgt-swatch-slider';
    row.parentNode.insertBefore(wrap, row);
    wrap.appendChild(row);

    const makeBtn = (dir) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `lbrgt-swatch-slider__btn lbrgt-swatch-slider__btn--${dir}`;
      btn.setAttribute('aria-label', dir === 'prev' ? 'Vorherige Farben' : 'Weitere Farben');
      btn.innerHTML = dir === 'prev'
        ? '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="m15 5-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="m9 5 7 7-7 7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.addEventListener('click', () => {
        const step = Math.max(row.clientWidth * 0.7, 80);
        row.scrollBy({ left: dir === 'prev' ? -step : step, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
      wrap.appendChild(btn);
      return btn;
    };

    const prev = makeBtn('prev');
    const next = makeBtn('next');

    const update = () => {
      const max = row.scrollWidth - row.clientWidth;
      prev.hidden = row.scrollLeft <= 2;
      next.hidden = row.scrollLeft >= max - 2;
      wrap.classList.toggle('lbrgt-swatch-slider--overflow', max > 2);
    };

    const showSelected = () => {
      const checked = row.querySelector('.opt-btn:checked + label');
      if (!checked) return;
      const left = checked.offsetLeft - row.offsetLeft;
      if (left < row.scrollLeft || left + checked.offsetWidth > row.scrollLeft + row.clientWidth) {
        row.scrollTo({ left: Math.max(left - 8, 0) });
      }
    };

    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    row.addEventListener('change', () => requestAnimationFrame(update));
    showSelected();
    update();
  };

  const init = () => {
    document.querySelectorAll('.lbrgt-vp--color-slider .option-selector__btns').forEach((row) => {
      if (row.querySelector('.opt-label--swatch')) initSlider(row);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
